<div class="education-search">
  <!-- Hero with search bar -->
  <div class="education-search__hero">
    <div class="vacancy-hero">
      <div class="education-search__search">
        <div class="education-search__search-fields">
          <div class="education-search__search-field">
            <div class="education-search__search-label">{{ 'shared.what' | translate }}</div>
            <div class="education-search__search-input-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
              </svg>
              <input
                type="text"
                [(ngModel)]="searchWat"
                (keydown.enter)="handleSearch()"
                [placeholder]="'educations.search.search_placeholder_what' | translate"
              />
              <button *ngIf="searchWat" class="education-search__clear" (click)="clearWat()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="education-search__search-divider"></div>

          <div class="education-search__search-field">
            <div class="education-search__search-label">{{ 'shared.where' | translate }}</div>
            <div class="education-search__search-input-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
              </svg>
              <input
                type="text"
                [(ngModel)]="searchWaar"
                (keydown.enter)="handleSearch()"
                [placeholder]="'educations.search.search_placeholder_where' | translate"
              />
              <button *ngIf="searchWaar" class="education-search__clear" (click)="clearWaar()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <button class="education-search__search-btn" (click)="handleSearch()">{{ 'shared.search' | translate }}</button>
      </div>

      <!-- Inline filters -->
      <div class="education-search__filters-inline">
        <lib-single-select-search
          class="education-search__filter-select"
          [options]="categorieOptions"
          [control]="categorieControl"
          [placeholder]="'educations.search.filter_categories' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onCategorieSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="regioOptions"
          [control]="regioControl"
          [placeholder]="'educations.search.filter_region' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onRegioSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="leervormOptions"
          [control]="leervormControl"
          [placeholder]="'educations.search.filter_learning_form' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onLeervormSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="prijsOptions"
          [control]="prijsControl"
          [placeholder]="'educations.search.filter_price' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onPrijsSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="aanbiederOptions"
          [control]="aanbiederControl"
          [placeholder]="'educations.search.filter_provider' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onAanbiederSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="subsidieOptions"
          [control]="subsidieControl"
          [placeholder]="'educations.search.filter_subsidy' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onSubsidieSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="startDatumOptions"
          [control]="startDatumControl"
          [placeholder]="'educations.search.filter_start_date' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onStartDatumSelected($event)"
        ></lib-single-select-search>

        <lib-single-select-search
          class="education-search__filter-select"
          [options]="taalOptions"
          [control]="taalControl"
          [placeholder]="'educations.search.filter_language' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onTaalSelected($event)"
        ></lib-single-select-search>
      </div>
    </div>
  </div>

  <!-- Results -->
  <div class="vacancy-container education-search__content">
    <div class="vacancy-grid">
      <bwc-education-card
        *ngFor="let education of visibleEducations"
        [education]="education"
        [isLiked]="isLiked(education.id)"
        (liked)="toggleLike($event)"
      ></bwc-education-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>
</div>
